<template>
  <div class="app-header-container">
    <div class="el-page-header app-header px-3 pt-3 pb-2 position-relative">
      <div class="app-header-title">
        {{ headerTitle }}
      </div>
      <div class="app-logo"></div>
      <div>
        <div v-if="isMain" class="hamburger-button" @click="showSideBar">
          <i class="el-icon-menu" />
        </div>
        <slot v-else name="right" />
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from '../../event-bus.js';
import TITLES from '../../config/navigation/page-app-header-title';
export default {
  name: 'AppHeader',
  components: {},
  props: {
    title: {
      type: String,
      default: null,
    },
    leftButton: {
      type: Function,
      default: () => {},
    },
    isMain: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    headerTitle() {
      return this.title ? this.title : this.$t(TITLES[this.$route.name]);
    },
  },
  methods: {
    showSideBar() {
      EventBus.$emit('sidebarToggle');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/colors';

.app-logo {
  position: absolute;
  left: calc(50% - 60px);
  top: 20px;
  display: none;
}
.app-header-container {
  z-index: 90;
  padding-top: env(safe-area-inset-top);
  box-shadow: 0 0 10px #929292;
}
.app-header {
  background: #fff;
  border-bottom: 1px solid black;
  padding: 0 10px 10px 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 3000;
  min-height: 44px;
}

.app-header-title {
  font-size: 1.2rem;
  font-weight: bold;
  font-family: 'Univers LT Bold Extended';
  color: $--color-dark-gray;
}

.hamburger-button {
  font-size: 30px;
  padding: 5px;
  border-radius: 10px;
  transition: all 0.25s ease-in-out;
  &:hover {
    background: $--color-hover-background;
  }
}

@media only screen and (min-width: 900px) {
  .hamburger-button {
    display: none;
  }

  .app-logo {
    top: 10px;
    display: block;
  }
}
</style>
